<template>
  <div class="business-status-card">
    <div class="card-header">
      <h3 class="title">Status do Negócio</h3>
      <business-status-selector
        :currentStatus="businessSettings.status"
        :isLoading="hasRequest"
        @statusChange="updateStatus"
      />
    </div>

    <div class="card-content">
      <div class="schedule-section">
        <div class="schedule-header">
          <h4 class="schedule-title">Horário de Funcionamento</h4>
        </div>

        <div class="schedule-grid">
          <business-schedule-day
            v-for="(day, dayName) in businessSettings.working_schedule"
            :key="dayName"
            :dayName="dayName"
            :schedule="day"
            :isLoading="hasRequest"
            @updateSchedule="updateDaySchedule"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { SellerStatus } from '@/store/modules/settingSeller';
  import BusinessStatusSelector from './BusinessStatusSelector';
  import BusinessScheduleDay from './BusinessScheduleDay';

  export default {
    name: 'BusinessStatusCard',

    data() {
      return {
        hasRequest: false,
        businessSettings: {
          status: SellerStatus.WORKING,
          working_schedule: {
            monday: {
              am: { start: null, end: null },
              pm: { start: null, end: null }
            },
            tuesday: {
              am: { start: null, end: null },
              pm: { start: null, end: null }
            },
            wednesday: {
              am: { start: null, end: null },
              pm: { start: null, end: null }
            },
            thursday: {
              am: { start: null, end: null },
              pm: { start: null, end: null }
            },
            friday: {
              am: { start: null, end: null },
              pm: { start: null, end: null }
            },
            saturday: {
              am: { start: null, end: null },
              pm: { start: null, end: null }
            },
            sunday: {
              am: { start: null, end: null },
              pm: { start: null, end: null }
            }
          }
        }
      };
    },

    components: {
      'business-status-selector': BusinessStatusSelector,
      'business-schedule-day': BusinessScheduleDay
    },

    computed: {
      ...mapGetters(['getCurrentSellerId', 'getCurrentSellerData'])
    },

    mounted() {
      this.fetchBusinessSettings();
    },

    watch: {
      'getCurrentSellerData.id'(value) {
        if (value) {
          this.fetchBusinessSettings();
        }
      }
    },

    methods: {
      async fetchBusinessSettings() {
        this.hasRequest = true;

        await this.$store
          .dispatch('settingSellerModule/getSettingSeller')
          .then((res) => {
            if (res) {
              this.businessSettings = {
                status: res.status || SellerStatus.WORKING,
                working_schedule:
                  res.working_schedule || this.businessSettings.working_schedule
              };
            }
          })
          .catch(() => {
            this.$emit(
              'snackbarNotification',
              'Erro ao carregar configurações',
              '#FF5A5A'
            );
          });

        this.hasRequest = false;
      },

      async updateStatus(newStatus) {
        this.hasRequest = true;

        await this.$store
          .dispatch('settingSellerModule/updateSellerStatus', newStatus)
          .then(() => {
            this.businessSettings.status = newStatus;
            this.$emit(
              'snackbarNotification',
              'Status atualizado com sucesso',
              '#08B978'
            );
          })
          .catch(() => {
            this.$emit(
              'snackbarNotification',
              'Erro ao atualizar status',
              '#FF5A5A'
            );
          });

        this.hasRequest = false;
      },

      async updateDaySchedule(dayName, newSchedule) {
        this.hasRequest = true;

        const updatedWorkingSchedule = {
          ...this.businessSettings.working_schedule,
          [dayName]: newSchedule
        };

        const data = {
          status: this.businessSettings.status,
          working_schedule: updatedWorkingSchedule
        };

        await this.$store
          .dispatch('settingSellerModule/updateSettingSeller', data)
          .then(() => {
            this.businessSettings.working_schedule = updatedWorkingSchedule;
            this.$emit(
              'snackbarNotification',
              `Horários de ${this.getDayLabel(dayName)} atualizados com sucesso`,
              '#08B978'
            );
          })
          .catch(() => {
            this.$emit(
              'snackbarNotification',
              'Erro ao atualizar horários',
              '#FF5A5A'
            );
          });

        this.hasRequest = false;
      },

      getDayLabel(dayName) {
        const dayLabels = {
          monday: 'Segunda-feira',
          tuesday: 'Terça-feira',
          wednesday: 'Quarta-feira',
          thursday: 'Quinta-feira',
          friday: 'Sexta-feira',
          saturday: 'Sábado',
          sunday: 'Domingo'
        };
        return dayLabels[dayName] || dayName;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .business-status-card {
    border: 1px solid #dadada;
    border-radius: 6px;
    background: white;

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1rem;
      padding: 1rem 1.5rem;
      border-bottom: 1px solid #dadada;

      .title {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        margin: 0;
      }
    }

    .card-content {
      padding: 1.5rem;

      .schedule-section {
        .schedule-header {
          margin-bottom: 1rem;

          .schedule-title {
            font-size: 14px;
            font-weight: 500;
            color: #333;
            margin: 0;
          }
        }

        .schedule-grid {
          display: grid;
          gap: 0.75rem;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .business-status-card {
      .card-content {
        padding: 1rem;

        .schedule-section {
          .schedule-grid {
            grid-template-columns: repeat(1, 1fr);
            gap: 0.5rem;
          }
        }
      }
    }
  }
</style>
